var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoInCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 68
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.333984,
    y: 0.00305176,
    width: 16,
    height: 16,
    rx: 8,
    fill: "#4732D4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Sign"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.10938 11.3608H5.97262L6.09174 10.8538H10.6139L10.7315 11.3608H12.5948V10.2442H4.10938V11.3608Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.10938 9.47844H6.41094L6.52854 8.973H10.1756L10.2932 9.47844H12.5948V8.36342H4.10938V9.47844Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.10938 7.59604H6.84773L6.96533 7.09061H9.73881L9.85641 7.59604H12.5948V6.48103H4.10938V7.59604Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.10938 4.60022V5.71523H7.28452L7.40212 5.2098H9.30202L9.41962 5.71523H12.5948V4.60022H4.10938Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoInCircle);
export default __webpack_public_path__ + "static/media/logoInCircle.d56e7bd31d6bb532100eed9db4df531c.svg";
export { ForwardRef as ReactComponent };